<template class="container">
  <div class="container">
    <b-modal :active.sync="isActive" scroll="keep">
      <div class="modal-card" style="width: auto;">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('history') | capitalize }}
          </p>
        </header>
        <section class="modal-card-body">
          <table class="table is-bordered" style="width: 100%;" v-if="historyOrder">
            <tr>
              <th colspan="6">{{ $translate('history') }}</th>
            </tr>
            <tr>
              <td colspan="6"></td>
            </tr>
            <tr>
              <td>
                <strong>{{ $translate('company') | capitalize }}:</strong>
              </td>
              <td colspan="2">{{ historyOrder.company.name }}</td>
              <td>
                <strong>{{ $translate('shop') | capitalize }}:</strong>
              </td>
              <td colspan="2">{{ historyOrder.shop.name }}</td>
            </tr>
            <tr>
              <td>
                <strong>{{ $translate('primaryCode') | capitalize }}:</strong>
              </td>
              <td>{{ historyOrder.primaryCode }}</td>

              <td>
                <strong>{{ $translate('orderTypeMain') | capitalize }}:</strong>
              </td>
              <td>
                {{ $translate(historyOrder.orderTypeMain) }}
                {{ $translate(historyOrder.orderTypeVariant) }}
              </td>

              <td>
                <strong>{{ $translate('deliveryType') | capitalize }}:</strong>
              </td>
              <td>
                {{ $translate(historyOrder.deliverySelected) }}
                {{ $translate(historyOrder.deliverySelectedSub) }}
              </td>
            </tr>
            <tr>
              <td colspan="6"></td>
            </tr>
            <tr>
              <th colspan="6">{{ $translate('order') }}</th>
            </tr>
            <tr>
              <td colspan="6"></td>
            </tr>
            <tr>
              <td>
                <strong>{{ $translate('created') | capitalize }}:</strong>
              </td>
              <td>
                {{ new Date(historyOrder.creationDate).toLocaleDateString() }}
              </td>
              <td>
                <strong>{{ $translate('mark_envo') | capitalize }}: </strong>
              </td>
              <td v-if="historyOrder.history">{{ getDateEvent('invord') }}</td>
              <td v-else>
                #
              </td>
              <td>
                <strong>{{ $translate('sendord_in') | capitalize }}:</strong>
              </td>
              <td v-if="historyOrder.history">{{ getDateEvent('sendord') }}</td>
              <td v-else>
                #
              </td>
            </tr>
            <tr>
              <td>
                <strong>{{ $translate('tec') | capitalize }}: </strong>
              </td>
              <td>
                {{ historyOrder.tec }}
              </td>
              <td>
                <strong>{{ $translate('tec') | capitalize }}: </strong>
              </td>
              <td v-if="historyOrder.history">
                {{ getTechEvent('invord') }}
              </td>
              <td v-else>
                #
              </td>
              <td>
                <strong>{{ $translate('tec') | capitalize }}: </strong>
              </td>
              <td v-if="historyOrder.history">
                {{ getTechEvent('sendord') }}
              </td>
              <td v-else>
                #
              </td>
            </tr>
            <tr>
              <td colspan="6"></td>
            </tr>
            <tr>
              <th colspan="6">{{ $translate('production') }}</th>
            </tr>
            <tr>
              <td colspan="6"></td>
            </tr>
            <tr>
              <td>
                <strong>{{ $translate('proc_order') | capitalize }}: </strong>
              </td>
              <td v-if="historyOrder.history">
                {{ getDateEvent('proc_order') }}
              </td>
              <td v-else>
                #
              </td>
              <td>
                <strong>{{ $translate('waitord') | capitalize }}: </strong>
              </td>
              <td v-if="historyOrder.history">
                {{ getDateEvent('waitord') }}
              </td>
              <td v-else>
                #
              </td>
              <td>
                <strong>{{ $translate('workord') | capitalize }}: </strong>
              </td>
              <td v-if="historyOrder.history">
                {{ getDateEvent('workord') }}
              </td>
              <td v-else>
                #
              </td>
            </tr>
            <tr>
              <td>
                <strong>{{ $translate('tec') | capitalize }}: </strong>
              </td>
              <td v-if="historyOrder.history">
                {{ getTechEvent('proc_order') }}
              </td>
              <td v-else>
                #
              </td>
              <td>
                <strong>{{ $translate('tec') | capitalize }}: </strong>
              </td>
              <td v-if="historyOrder.history">
                {{ getTechEvent('waitord') }}
              </td>
              <td v-else>
                #
              </td>
              <td>
                <strong>{{ $translate('tec') | capitalize }}: </strong>
              </td>
              <td v-if="historyOrder.history">
                {{ getTechEvent('workord') }}
              </td>
              <td v-else>
                #
              </td>
            </tr>
            <tr>
              <td colspan="6"></td>
            </tr>
            <tr>
              <td>
                <strong>{{ $translate('endord') | capitalize }}: </strong>
              </td>
              <td v-if="historyOrder.history">
                {{ getDateEvent('endord') }}
              </td>
              <td v-else>
                #
              </td>
              <td>
                <strong>{{ $translate('courier') | capitalize }}: </strong>
              </td>

              <td v-if="historyOrder.history">
                {{ getDateEvent('courier') }}
              </td>
              <td v-else>
                #
              </td>
              <td>
                <strong>{{ $translate('closed') | capitalize }}: </strong>
              </td>

              <td v-if="historyOrder.history">
                {{ getDateEvent('closed') }}
              </td>
              <td v-else>
                #
              </td>
            </tr>
            <tr>
              <td colspan="6"></td>
            </tr>
            <tr>
              <th colspan="6">{{ $translate('claim') }}</th>
            </tr>
            <tr>
              <td colspan="6"></td>
            </tr>
            <template v-for="claim in historyOrder.claims">
              <tr :key="'claimsup' + claim.id" v-if="!claim.deleted">
                <th colspan="2" rowspan="2">
                  {{ claim.primaryCode }}
                </th>
                <td>
                  <strong>{{ $translate('creation_date') | capitalize }}: </strong>
                </td>
                <td>{{ new Date(claim.creationDate).toLocaleDateString() }}</td>
                <td v-if="claim.AdminClaim">
                  <strong>{{ $translate('reception_date') | capitalize }}: </strong>
                </td>
                <td v-if="claim.AdminClaim">
                  {{ claim.answercreationDate ? new Date(claim.answercreationDate).toLocaleDateString() : '' }}
                </td>
              </tr>
              <tr :key="'claimunder' + claim.id" v-if="!claim.deleted">
                <td>
                  <strong>{{ $translate('tec') | capitalize }}: </strong>
                </td>
                <td>{{ claim.tec }}</td>
                <td v-if="claim.AdminClaim">
                  <strong>{{ $translate('user') | capitalize }}: </strong>
                </td>
                <td v-if="claim.AdminClaim">
                  {{ claim.answertec }}
                </td>
              </tr>
            </template>
          </table>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="isActive = false">
            Close
          </button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'HistoryOrderModal',
  props: ['historyModalBool', 'historyOrder'],
  computed: {
    isActive: {
      get() {
        return this.historyModalBool
      },
      set(val) {
        this.$emit('update:historyModalBool', val)
      },
    },
  },
  methods: {
    getEvent(status) {
      const events = this.historyOrder.history.filter(e => e.newStatus === status)
      const event = events[events.length - 1]
      if (status === 'compord' || status === 'sendord') return event
      if (events[events.length - 1]) {
        const sendOrdEvent = this.getEvent('sendord')
        if (sendOrdEvent && event && sendOrdEvent.date < event.date) return event
      }
      //return this.historyOrder.history.find(e => e.newStatus === status)
    },
    getDateEvent(status) {
      const event = this.getEvent(status)
      return event ? new Date(event.date).toLocaleDateString() : '#'
    },
    getTechEvent(status) {
      const event = this.getEvent(status)
      return event ? event.technician : '#'
    },
  },
}
</script>
<style scoped>
.container >>> th {
  background-color: #008a6b !important;
  text-transform: uppercase;
  color: #f5f5f5;
  vertical-align: middle;
  text-align: center;
}
</style>
